import React, { useState } from 'react';
import { FormattedMessage } from 'react-intl';
import { NamedLink, ExternalLink, Icons } from '../../../../components';
import css from './TopbarDesktop.module.css';
import classNames from 'classnames';

const RenderNavMenu = ({ menuOptions }) => {
  const [openDropdown, setOpenDropdown] = useState(null);
  const [openSubmenu, setOpenSubmenu] = useState(null);

  return (
    <ul className={css.dropdownMenu}>
      {menuOptions.map((menu, index) => (
        <li
          key={index}
          className={css.dropdownMenuItem}
          onMouseEnter={() => setOpenDropdown(index)}
          onMouseLeave={() => setOpenDropdown(null)}
        >
          <span className={css.navLink}>
            <FormattedMessage id={menu.label} />
            {menu.subMenu && <Icons name="downAngle" />}
          </span>

          {openDropdown === index && menu.subMenu && (
            <ul className={css.subDropdownMenu}>
              {menu.subMenu.map((submenu, subIndex) => (
                <li key={subIndex} className={css.subDropdownItem}>
                  {submenu.subSubMenu ? (
                    <span
                      className={css.navLink}
                      onClick={() => setOpenSubmenu(openSubmenu === subIndex ? null : subIndex)}
                    >
                      <FormattedMessage id={submenu.label} />
                      <Icons name="rightAngle" />
                    </span>
                  ) : submenu.type === 'external' ? (
                    <ExternalLink
                      className={classNames(css.navLink, css.subMenu)}
                      href={submenu.href}
                    >
                      <FormattedMessage id={submenu.label} />
                    </ExternalLink>
                  ) : (
                    <NamedLink
                      className={classNames(css.navLink, css.subMenu)}
                      name={submenu.href}
                      params={submenu?.params}
                    >
                      <FormattedMessage id={submenu.label} />
                    </NamedLink>
                  )}

                  {openSubmenu === subIndex && submenu.subSubMenu && (
                    <ul className={css.subSubDropdownMenu}>
                      {submenu.subSubMenu.map((subSubItem, subSubIndex) => (
                        <li key={subSubIndex} className={css.subSubDropdownItem}>
                          {subSubItem.type === 'external' ? (
                            <ExternalLink
                              className={classNames(css.navLink, css.subMenu)}
                              href={subSubItem.href}
                            >
                              <FormattedMessage id={subSubItem.label} />
                            </ExternalLink>
                          ) : (
                            <NamedLink
                              className={classNames(css.navLink, css.subMenu)}
                              name={subSubItem.href}
                              params={submenu?.params}
                            >
                              <FormattedMessage id={subSubItem.label} />
                            </NamedLink>
                          )}
                        </li>
                      ))}
                    </ul>
                  )}
                </li>
              ))}
            </ul>
          )}
        </li>
      ))}
    </ul>
  );
};

export default RenderNavMenu;
